export { default } from './useOnMount';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useOnMount/index.js
// module id = 1743
// module chunks = 25